import { Box, Button, Typography } from '@material-ui/core'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { CtLiveApiStatus } from '../../utils/types'

import { useEntryStatusCardStyles, useSharedStyles } from './styles'
import { FormattedEventEntry } from './AthleteCard'

type EntryStatusCardProps = {
  athlinksEventCourseId: number | null
  eventId: number
  formattedEntry: FormattedEventEntry | null
  masterId: number | null
}

const statusesToShow = [
  CtLiveApiStatus.Withdrawn,
  CtLiveApiStatus.Deferred,
  CtLiveApiStatus.Pending,
  CtLiveApiStatus.NotSelected,
]

const EntryStatusCard = ({ athlinksEventCourseId, eventId, formattedEntry, masterId }: EntryStatusCardProps) => {
  const styles = useEntryStatusCardStyles()
  const sharedStyles = useSharedStyles()

  const title = useMemo(() => {
    if (!formattedEntry) {
      return null
    }

    if (formattedEntry.status === CtLiveApiStatus.NotSelected) {
      return `This Entry was ${formattedEntry.statusLabel}`
    }

    return `This Entry is ${formattedEntry.statusLabel}`
  }, [formattedEntry])

  if (!formattedEntry || !statusesToShow.includes(formattedEntry.status)) {
    return null
  }

  return (
    <Box className={`${sharedStyles.paper} ${styles.container}`}>
      <Typography className={`${sharedStyles.title} ${styles.title}`}>
        {title}
      </Typography>

      <Link to={`/event/${masterId}/roster/Event/${eventId}/Course/${athlinksEventCourseId}`}>
        <Button className={styles.rosterButton} variant="outlined">
          View Roster
        </Button>
      </Link>
    </Box>
  )
}

export { EntryStatusCard }